export const NON_SIDENAV_ROUTE = ['get_started', 'sign_up', 'application_status', 'success_signup', 'success_signup_status', 'login', 'login_page']
export const SUPPORT_TABS = ['Dashboard', 'Inventory Hub', 'Promotions', 'Applications', 'Impersonate', 'MFP Numbers', 'DropShip', 'Quarterly Earnings Upload']
export const INVENTORY_INGESTION_HUB_TAB = ['Inventory Hub']
export const DROPSHIP_TAB = ['DropShip']
